import React, { useState } from 'react';
import PropTypes from 'prop-types';

import SrFormikField, { SR_FIELD_THEME_ADOBE } from 'client/components/SrFormikField';

import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';
import ButtonDeprecated, { BUTTON_THEME_BLUE_GREYCLIFF } from 'client/components/ButtonDeprecated';

import './SrSunSetupDriverJobPage.less';

const VIEW_STATE_INPUT = 'VIEW_STATE_INPUT';
const VIEW_STATE_VALUE = 'VIEW_STATE_VALUE';

const SrSunSetupDriverJobComboLockboxCodes = ({
  formikBag,
  getFormFieldsById,
  onUpdateJob,
  onUpdateListing,
}) => {
  const lockboxCode = formikBag.values.details?.lockboxCode;

  const [lockboxCodeViewState, setLockboxCodeViewState] = useState(
    lockboxCode ? VIEW_STATE_VALUE : VIEW_STATE_INPUT,
  );

  const _onSubmitClick = () => {
    if (!lockboxCode) {
      return;
    }

    onUpdateJob({
      updates: {
        details: {
          ...(formikBag.values.details || {}),
          lockboxCode,
        },
      },
    });

    onUpdateListing({
      updates: {
        lockboxCode,
      },
    });
    setLockboxCodeViewState(VIEW_STATE_VALUE);
  };

  const _onEditClick = () => {
    setLockboxCodeViewState(VIEW_STATE_INPUT);
  };

  return (
    <>
      <div styleName="card">
        <span styleName="cardTitle">Combo Lockbox Code</span>

        <SrBox paddingTop="8px">
          <SrText font="greycliff" fontSize="14px" weight="500" lineHeight="20px">
            Set a random 4 digit combo code for the lock. Test to ensure this combo works. Type the
            code you set below.
          </SrText>
        </SrBox>

        {lockboxCodeViewState === VIEW_STATE_INPUT && (
          <div>
            <SrFormikField
              formField={getFormFieldsById('details.lockboxCode')}
              formikBag={formikBag}
              theme={SR_FIELD_THEME_ADOBE}
            />
            <ButtonDeprecated
              theme={BUTTON_THEME_BLUE_GREYCLIFF}
              onClick={() => _onSubmitClick()}
              margin="20px 0"
            >
              Submit
            </ButtonDeprecated>
          </div>
        )}

        {lockboxCodeViewState === VIEW_STATE_VALUE && (
          <SrBox paddingTop="24px">
            <div styleName="jobDetailsBox" style={{ paddingBottom: '10px' }}>
              <span styleName="title">Combo Lockbox Code</span>
              <br />
              <span styleName="bigValue">{lockboxCode}</span>
            </div>
            <SrBox margin="16px 0 0" textAlign="center">
              <SrText
                font="greycliff"
                weight="800"
                color="blue300"
                decoration="underline"
                fontSize="16px"
                cursor="pointer"
                onClick={() => _onEditClick('verifyBedrooms')}
              >
                Edit Number
              </SrText>
            </SrBox>
          </SrBox>
        )}
      </div>
    </>
  );
};

SrSunSetupDriverJobComboLockboxCodes.propTypes = {
  formikBag: PropTypes.object.isRequired,
  getFormFieldsById: PropTypes.func.isRequired,
  onUpdateJob: PropTypes.func.isRequired,
  onUpdateListing: PropTypes.func.isRequired,
};

SrSunSetupDriverJobComboLockboxCodes.displayName = 'SrSunSetupDriverJobComboLockboxCodes';

export default SrSunSetupDriverJobComboLockboxCodes;
